<template>
  <div class="comments-section">
    <comment-input
      v-model="newComment"
      @submit="submitComment"
      @cancel="cancelComment"
    />

    <div class="comment" v-for="c in comments" :key="c.id">
      <div class="content">
        <div class="meta">
          <span class="name">@{{ c.sellerId }}</span>
          <span class="time">{{ formatDate(c.createDate) }}</span>
        </div>
        <!-- <div class="text">{{ c.content }}</div> -->
        <div class="text" v-if="editingCommentId !== c.id">{{ c.content }}</div>
        <comment-input
          v-else
          v-model="editingContent"
          placeholder="コメントを編集..."
          submitText="保存"
          :autoFocus="true"
          @submit="updateComment(c)"
          @cancel="cancelEdit"
        />
        <div class="actions" v-if="editingCommentId !== c.id">
          <like-button
            :item="c"
            @handleClickLike="$emit('handleLikeComment', c)"
          />
          <button title="返信" @click="handleClickShowReplies(c)" :class="{ 'text-primary': c.isShowReplies }">
            <i class="fa fa-reply-all" aria-hidden="true"></i>
            {{ c.replies.length }}
          </button>
          <button title="編集" v-if="sellerId === c.sellerId" @click="handleClickEditComment(c)"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></button>
          <!-- <button title="削除" v-if="sellerId === c.sellerId"><i class="fa fa-trash" aria-hidden="true"></i></button> -->
        </div>
        <div v-if="c.isShowReplies" v-for="r in c.replies" :key="r.id" class="comment">
          <div class="content">
            <div class="meta">
              <span class="name">@{{ r.sellerId }}</span>
              <span class="time">{{ formatDate(r.createDate) }}</span>
            </div>
            <div class="text" v-if="editingCommentId !== r.id">{{ r.content }}</div>
            <comment-input
              v-else
              v-model="editingContent"
              placeholder="コメントを編集..."
              submitText="保存"
              :autoFocus="true"
              @submit="updateComment(r)"
              @cancel="cancelEdit"
            />
            <div class="actions" v-if="editingCommentId !== r.id">
              <like-button
                :item="r"
                @handleClickLike="$emit('handleLikeComment', r)"
              />
              <button title="編集" v-if="sellerId === r.sellerId" @click="handleClickEditComment(r)"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></button>
              <!-- <button title="削除" v-if="sellerId === r.sellerId"><i class="fa fa-trash" aria-hidden="true"></i></button> -->
            </div>
          </div>
        </div>
        <comment-input
          v-if="replyInputs[c.id] !== undefined && !editingCommentId"
          v-model="replyInputs[c.id]"
          placeholder="返信を追加..."
          submitText="返信"
          :autoFocus="true"
          @submit="submitReply(c)"
          @cancel="cancelReply(c)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import 'moment/locale/ja'
import LikeButton from './LikeButton'
import CommentInput from './CommentInput'

export default {
  props: {
    comments: {
      type: Array
    },
    sellerId: {
      type: String
    }
  },
  components: {
    LikeButton,
    CommentInput
  },
  data () {
    return {
      newComment: '',
      editingCommentId: null,
      editingContent: '',
      replyInputs: {}
    }
  },
  mounted () {
    moment.locale('ja')
  },
  methods: {
    formatDate (date) {
      return moment(date).fromNow()
    },
    submitComment () {
      this.$emit('submitComment', this.newComment)
      this.cancelComment()
    },
    cancelComment () {
      this.newComment = ''
    },
    handleClickEditComment (comment) {
      this.editingCommentId = comment.id
      this.editingContent = comment.content
    },
    updateComment (comment) {
      comment.content = this.editingContent
      this.$emit('updateComment', comment)
      this.cancelEdit()
    },
    cancelEdit () {
      this.editingContent = ''
      this.editingCommentId = null
    },
    handleClickShowReplies (comment) {
      comment.isShowReplies = !comment.isShowReplies
      this.toggleReplyInput(comment.id)
    },
    toggleReplyInput (parentId) {
      if (this.replyInputs[parentId] === undefined) {
        this.$set(this.replyInputs, parentId, '')
      } else {
        this.$delete(this.replyInputs, parentId)
      }
    },
    async submitReply (comment) {
      const content = this.replyInputs[comment.id]
      if (!content.trim()) return
      this.$emit('submitReply', comment, content)
      this.$set(this.replyInputs, comment.id, '')
    },
    cancelReply (comment) {
      if (comment.replies.length > 0) {
        this.$set(this.replyInputs, comment.id, '')
      } else {
        comment.isShowReplies = false
        this.$delete(this.replyInputs, comment.id)
      }
    }
  }
}
</script>
<style scoped>
.comments-section {
  font-size: 16px;
  color: #000;
  margin-top: 20px;

  .comment {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    position: relative;

    .content {
      flex: 1;
      padding: 10px 20px;

      .meta {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 14px;
        color: #555;

        .name {
          font-weight: bold;
          text-decoration: underline;
        }
      }

      .text {
        margin: 4px 0;
        padding: 0 20px;
      }

      .actions {
        display: flex;
        align-items: center;
        color: #555;
        font-size: 18px;
        padding: 0 20px;

        button {
          &:hover {
            color: #87c4f5;
          }
          background: none;
          border: none;
          cursor: pointer;
        }
      }
    }

    .menu {
      position: absolute;
      right: 0;
      top: 0;
      background: none;
      border: none;
      font-size: 18px;
      cursor: pointer;
    }
  }
}
.text-primary {
  color: #2196f3;
}
</style>



// WEBPACK FOOTER //
// src/view/video/components/VideoComments.vue